import List from './list';
import Edit from './edit';

let routes = [];
routes = routes.concat({ path: 'list', exact: true, name: 'basic', component: <List /> });
routes = routes.concat({ path: 'edit', exact: true, name: 'basic', component: <Edit /> });
routes = routes.concat({ path: 'edit/:id', exact: true, name: 'basic', component: <Edit /> });

export default routes;
